export default {
  namespaced: true,
  unit: {
    contacts_template_download_error: "Could not download the template with sections. Please try again.",
    contacts_template_no_sections: "No sections are available to create the template.",
    contacts_import_template: "Import from template",
    contacts_template_hint: "Contacts will be added to the list for editing and saved when you click Save changes. Enter phone numbers as text to preserve leading zeros and prefixes.",
    contacts_template_invalid: "Select a valid XLSX template up to 5 MB, without formulas and with the Sección, Teléfono, Nombre and Descripción columns.",
    contacts_template_browser: "This browser cannot read the template. Use a recent version of Chrome, Edge, Firefox or Safari.",
    contacts_template_empty: "The template contains no contacts.",
    title: "Facility | Facilities",
    single: "facility",
    all: "all facilities",
    description: "description",
    address_1: "address 1",
    address_2: "address 2",
    exterior_number: "exterior number",
    suburb: "suburb",
    number: "Interior Number",
    postal_code: "zip code",
    route: "route",
    plate_number: "plate number",
    vin: "VIN",
    driver: "driver",
    provider: "provider",
    owner: "owner",
    company: "company",
    vehicle: "Is a vehicle?",
    reaction_patrol: "reaction patrol",
    allow_virtual_button_alarm: "allow virtual button alarm",
    active_digital_output: "active digital output",
    camera_count: "cameras",
    timeZone: "timezone",
    example: "example",
    disable: "Disable facility",
    disable_comment: "Comment",
    reactivation_date: "Reactivation Date",
    deactivation_date: "Deactivation date",
    required_deactivation_catalog: "The 'Facility Deactivation Catalog' field is required",
    required_comment: "The 'Comment' field is required",
    location: "Location",
    emergency_contacts: "Emergency Contacts",
    title_app: "Facility SBO Mobile",
    description_app: "Facility that will be used to generate incidents through the SBO Mobile",
    category: "Category",
    additional_info: "Additional Information",
    key: "Clave",
    value: "Valor",
    import_from_template: "Import From Template",
    download_template: "Download template",
    add_from_form: "Add From Form",
    template: "Plantilla",
    select_template: "Select template",
    search: "Search",
    name: 'Name',
    phone_number: 'Phone',
    section: 'Section',
    add_contact: 'Add contact',
    remove_contact: 'Remove',
    assign_task: 'Assign task',
    task_type: 'Type',
    task_type_inmuebles: 'Facilities',
    task_type_form: 'Form',
    task_type_completar_form: 'Complete form',
    task_type_create_form_with_relation: 'Create form with relation',
    assigned_task: 'Facility assignment',
    assigned_form_task: 'Form assignment',
    assigned_task_details: 'Facility assignment details',
    assigned_form_task_details: 'Form assignment details',
    assigned_security_form_task: 'Security form assignment',
    assigned_security_form_task_details: 'Security form assignment details',
    panel_failure_task: 'Panel failure',
    panel_failure_task_hint: 'Drag the notification into a slot to see the alarm',
    mark_as_done: 'Mark as done',
    zone_number: 'Zone',
    region_label: 'Region',
    task_status: {
      pending: 'Pending',
      done: 'Done',
      cancelled: 'Cancelled'
    },
    enable_nearby_locations: 'Enable nearby locations',
    distance: 'Distance',
    needs_check: 'Allow ping',
    getLatLng: 'Retrieve latitude, longitude and timezone from the address',
    ip_address: 'IP Address',
    subnet_mask: 'Subnet Mask',
    invalid_ip_format: 'Invalid IP format',
    invalid_range: 'Invalid range',
    ip_required: 'IP address is required',
    mask_required: 'Subnet mask is required',
    attachments: 'Attachments (Maximum 3)',
    no_data: 'No data',
    tenant: 'Tenant',
    center: 'Center',
    sector: 'Sector',
    id_totem: 'ID Totem',
    totem_key: 'Totem Key',
    id_seproban: 'ID Seproban',
    rems: 'REMS',
    sirh: 'SIRH',
    duplicate_facility_title: 'A Facility with this REMS/SIRH already exists',
    open_existing_new_tab: 'Open existing in new tab',
    merge: 'Perform Merge',
    duplicate_facility_message: 'Open the unit in another tab to edit it, or create the new one/update and perform the full merge.',
    file_limit_reached: 'Limit reached',
    file_limit_message: 'You can only upload a maximum of 3 files',
    invalid_file_type: 'Invalid file type',
    invalid_file_message: 'The file "{fileName}" is not an allowed format',
    downloading_file: 'Downloading file...',
    last_completed_result: 'Last approved evaluation result',
    reference_number: 'Reference',
    template_label: 'Template',
    no_completed_evaluations: 'This facility does not yet have an approved evaluation.',
    no_result_found: 'No result found',
    reverse_geocoder_failed: 'Reverse geocoder failed',
    bank_data: 'Bank Data',
    correct_address_warning: "It is important to provide all address details so that the coordinates (Latitude/Longitude/Time Zone) can be calculated accurately.",
    is_disabled: "Is it activated?",
    deactivated_data: "Deactivation Information",
    entity: "Entity",
    configuration_date: "Configuration Date",
    installation_date: "Installation Date",
    c5_router_label: "C5 Router Label",
    router_serial_number: "Router Serial Number",
    router_model: "Router Model",
    router_brand: "Router Brand",
    user: "User",
    password: "Password",
    ip_vpn: "VPN",
    mac_address: "Mac Address",
    router_serial_number: "Router Serial Number",
    router_model: "Router Model",
    router_brand: "Router Brand",
    user: "User",
    password: "Password",
    is_main_unit: "Is Main Facility",
    add_filters: "Add filters",
    toggle_detail_search: "Show or hide the search inside the details",
    is_saturday: "Saturday",
    id_cashier: "ID Cashier",
  },
};
